import { Container } from "react-bootstrap";
import MainNavbar from "../components/mainnavbar";
import Footer from "../components/footer";
import MessageHub from "../components/messagehub";
import ScrollToTopButton from "../components/scrolltotopbutton";
import ContactButton from "../components/contactbutton";
import RHFButtonListSelect from "../rhf/rhfbuttonlistselect";
import React from "react";
import { useBootstrapQuickLinks } from "../hooks/useQuickLinksData";

const LoggedInLayout = ({children}) => {
    useBootstrapQuickLinks();
    return(
        <div className="mainwrapper">
            <MainNavbar />
            <Container fluid className="pt-4 pb-4 maincontainer">
                {children}
            </Container>
            <Footer />
            <MessageHub />
            <ScrollToTopButton />
        </div>
    )
}

export default LoggedInLayout;
